export default {
      id: "error-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#error-usage",
      toString: function () {
        return this.url;
      }
    }